import { basicEnum } from "./base";

export const TroubleshootStepStatusEnum = basicEnum([
    {
        label: "EMPTY",
        value: "E",
    },
    {
        label: "INITIALIZED",
        value: "I",
    },
    {
        label: "STARTED",
        value: "S",
    },
    {
        label: "FINISHED",
        value: "F", // Filling reports and used items
    },
    {
        label: "REPORTED",
        value: "R", // Filling items price
    },
    {
        label: "DONE",
        value: "D",
    },
]);

export namespace TroubleshootStepStatusEnum {
    export type Labels = (typeof TroubleshootStepStatusEnum)["labels"][number];
    export type Values = (typeof TroubleshootStepStatusEnum)["values"][number];
}
